<template>
  <v-row>
    <v-col cols="6">
      <v-text-field
        v-model="data.business_name"
        label="Business Name"
      ></v-text-field>
    </v-col>

    <v-col cols="6">
      <v-text-field v-model="data.email" label="Email"></v-text-field>
    </v-col>

    <v-col cols="6">
      <v-text-field v-model="data.website" label="Website"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.address" label="Address"></v-text-field>
    </v-col>

    <v-col cols="6">
      <v-text-field v-model="data.telephone" label="Phone"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.mobile" label="Mobile"></v-text-field>
    </v-col>

    <v-col cols="6">
      <select-categories v-model="data.category"></select-categories>
    </v-col>
    <v-col cols="6">
      <select-suburbs v-model="data.suburb"></select-suburbs>
    </v-col>

    <v-col cols="12">
      <v-textarea
        rows="3"
        label="Description"
        v-model="data.description"
      ></v-textarea>
    </v-col>

    <v-col cols="6">
      <v-switch v-model="data.active" label="Active"></v-switch>
    </v-col>
    <v-col cols="6">
      <v-switch v-model="data.verified" label="Verified"></v-switch>
    </v-col>
  </v-row>
</template>

<script>
import SelectCategories from '../../../components/SelectCategories'
import SelectSuburbs from '../../../components/SelectSuburbs'
export default {
  name: 'FreeListingForm',
  props: ['data'],
  components: {
    SelectCategories,
    SelectSuburbs
  },

  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped></style>
